import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { firstValueFrom } from 'rxjs';
import { UntilDestroy } from '@ngneat/until-destroy';
import { TranslateService } from '@ngx-translate/core';
import { Group } from 'app/models/menu.model';
import { Store } from '@ngrx/store';
import { selectOriginalDictionaryGroups } from 'app/reducers/menu.selectors';
import { MenuScheduleModalData } from 'app/models/menu.schedule.model';

@UntilDestroy()
@Component({
  selector: 'app-select-groups-schedule-modal',
  templateUrl: './select-groups-schedule-modal.component.html',
  styleUrls: ['./select-groups-schedule-modal.component.scss']
})
export class SelectGroupsScheduleModalComponent implements OnInit {
  groups: Group[];
  menuSchedule: MenuScheduleModalData;
  selectedGroupIds: Set<string> = new Set<string>();

  constructor(
    public dialogRef: MatDialogRef<SelectGroupsScheduleModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: MenuScheduleModalData,
    private translate: TranslateService,
    private store: Store,
  ) {
    this.menuSchedule = this.data;
    this.menuSchedule.groupIds?.forEach(id => this.selectedGroupIds.add(id));
  }

  async ngOnInit() {
    const groupsMap = await firstValueFrom(this.store.select(selectOriginalDictionaryGroups));
    this.groups = [...groupsMap.values()];
  }

  get title(): string {
    return this.translate.instant('MENU.SELECT_SCHEDULE_GROUPS', {name: this.menuSchedule.name});
  }

  save(): void {
    const newGroupsIds: string[] = [];
    this.selectedGroupIds.forEach(id => newGroupsIds.push(id));
    this.menuSchedule.groupIds = newGroupsIds;
    this.dialogRef.close();
  }

  handleCheckGroup(group: Group, checked: boolean): void {
    if (checked) {
      this.selectedGroupIds.add(group.externalId);
    } else {
      this.selectedGroupIds.delete(group.externalId);
    }
  }

  isChecked(group: Group): boolean {
    return this.selectedGroupIds.has(group.externalId);
  }
}
